import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import VerticalDivider from '@/common/components/VerticalDivider/VerticalDivider'

import * as Styles from './styles'

const ParcelCardService = ({ methodName, isReveniContract }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!methodName && !isReveniContract) return null

  return (
    <Styles.Container>
      {methodName && (
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {methodName}
        </Text>
      )}
      {methodName && isReveniContract && <VerticalDivider role="separator" aria-orientation="vertical" />}
      {isReveniContract && (
        <Styles.ReveniRate>
          <Styles.ReveniLogo src="/logos/reveni_icon.svg" alt="" />
          <Text type="bodySMedium">{t('Reveni rate')}</Text>
        </Styles.ReveniRate>
      )}
    </Styles.Container>
  )
}

export default ParcelCardService
